import React, { Component } from 'react'
import { Form, Field } from 'react-final-form'
import { FormattedMessage, injectIntl } from 'react-intl'

import intlMessages from '../translations'
import { Box, Text } from '@chakra-ui/react'
import { TextArea } from 'src/components/Form'
import Button from 'src/components/Button/Button'

class ChangeRequestForm extends Component {
  handleSubmit = values => {
    this.props.onSubmit(values)
  }

  validateFormFields = values => {
    const { intl } = this.props
    const errors = {}

    if (!values.commentsText) {
      errors.commentsText = intl.formatMessage(intlMessages.otherValidationComments)
    }

    return errors
  }

  render() {
    const { intl, submitting } = this.props

    return (
      <Form
        onSubmit={this.handleSubmit}
        validate={this.validateFormFields}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Text fontWeight={500} variant='secondary' mt={'20px'} fontSize={'16px'}>
              <FormattedMessage
                id='app.other.fieldLabel'
                defaultMessage='What do you want to change?'
              />
            </Text>

            <Field
              name='commentsText'
              render={({ input, meta }) => (
                <Box mt={'16px'} mb={'25px'}>
                  <TextArea
                    name='commentsText'
                    error={meta}
                    placeholder={intl.formatMessage(intlMessages.otherPlaceHolderComments)}
                    {...input}
                  />
                </Box>
              )}
            />

            <Button isFullWidth size='lg' type='submit' isLoading={submitting}>
              <FormattedMessage id='app.other.submit' defaultMessage='Submit' />
            </Button>
          </form>
        )}
      />
    )
  }
}

export default injectIntl(ChangeRequestForm)
